import Vue from 'vue'
import Vuex from 'vuex'
import startJob from "./module/startJob"
import listProjects from "./module/listProjects";
import alert from "./module/alert";
import todayTimes from "./module/todayTimes";
import createTable from "./module/createTable";
import fileReport from "./module/fileReport";
import user from "./module/user";
import issues from "./module/issues";
import admin from "../store/module/admin/admin";
import users from "../store/module/admin/users";
import costsStore from "./module/admin/costsStore";

import {getLastTimes} from "../api/listTime";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    startJob,
    listProjects,
    alert,
    todayTimes,
    createTable,
    fileReport,
    user,
    issues,
    admin,
    users,
    costsStore,
  },
  state: {
    adminMenu: false,
    dialogTime : false,
    isIntegrationSet:false,
    startTimeToggle:false,
    time:false,
    timeDialog:'00:00',
    showTime:'۰۰:۰۰:۰۰',
    watchForStartTime:false,
    watchForTodayTime:false,
    lastTimeId:0,
    lastTimeProject: []
  },
  mutations: {
    ADMIN_MENU(state, data){
      state.adminMenu = data;
    },
    SET_LAST_TIME_PROJECT(state, data){
      state.lastTimeProject = data
    }
  },

 getters: {
    getAdminMenu(state){
      return state.adminMenu;
    },
   get_lastTimes(state){
      return state.lastTimeProject
   }
  },

  actions: {
    async fetchLastTimeProject({commit},params){
        try {
          let resp = await getLastTimes(params);
          commit('SET_LAST_TIME_PROJECT', resp.data);
        } catch (e) {
          //
        }
    }
  },

})
